var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHvac = function SvgHvac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.277 79.28c21.662 0 39.222-17.56 39.222-39.222C79.5 18.396 61.94.836 40.277.836c-21.662 0-39.222 17.56-39.222 39.222 0 21.662 17.56 39.222 39.222 39.222Z",
    fill: "#fff",
    stroke: "#A7A398"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "hvac_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 51,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 15H15v51h51V15Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hvac_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.177 49.49a6.528 6.528 0 0 0 4.426 9.996h.096l2.09-9.633a9.412 9.412 0 0 1-5.417-2.267l-1.196 1.904ZM41.21 49.87l.471 2.154a6.534 6.534 0 0 0 10.201 3.966l.074-.057-5.326-8.285a9.412 9.412 0 0 1-5.418 2.222h-.001ZM49.87 39.792l2.153-.47A6.534 6.534 0 0 0 55.99 29.12l-.057-.074-8.285 5.326a9.4 9.4 0 0 1 2.222 5.418v.001ZM33.363 34.373l-1.859-1.196a6.528 6.528 0 0 0-9.996 4.425v.096l9.633 2.09a9.401 9.401 0 0 1 2.221-5.417l.001.002ZM31.125 41.21l-2.154.471a6.534 6.534 0 0 0-3.966 10.202l.056.073 8.285-5.326a9.398 9.398 0 0 1-2.221-5.418v-.001ZM47.633 46.628l1.859 1.196a6.528 6.528 0 0 0 9.996-4.426V43.3l-9.633-2.09a9.4 9.4 0 0 1-2.221 5.418l-.001-.001ZM39.792 31.132l-.47-2.154a6.534 6.534 0 0 0-10.201-3.966l-.074.057 5.326 8.285a9.413 9.413 0 0 1 5.418-2.221l.001-.001ZM47.824 31.504a6.528 6.528 0 0 0-4.426-9.996H43.3l-2.09 9.633c2.002.159 3.9.952 5.418 2.267l1.196-1.905-.001.001Z",
    fill: "#647F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.608 40.504a6.107 6.107 0 0 0-10.426-4.317 6.107 6.107 0 0 0 1.98 9.965 6.11 6.11 0 0 0 8.446-5.647Z",
    fill: "#B06148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 15a25.498 25.498 0 0 0-18.031 43.531A25.5 25.5 0 0 0 66 40.5 25.528 25.528 0 0 0 40.5 15Zm16.91 39.667a22.09 22.09 0 0 1-16.91 7.916 22.1 22.1 0 0 1-21.998-20.167c-.05-.63-.102-1.27-.102-1.916a22.096 22.096 0 0 1 20.184-21.998c.63-.05 1.27-.102 1.916-.102a22.099 22.099 0 0 1 21.998 24.02 21.98 21.98 0 0 1-5.088 12.247Z",
    fill: "#0D291C"
  }))));
};
export default SvgHvac;